import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const Video = ({
	url, placeholder
}) => {
	const ref = useRef();
	const [inViewRef, inView] = useInView();
	const [hasLoaded, setHasLoaded] = useState(false)

	// Use `useCallback` so we don't recreate the function on each render - Could result in infinite loop
	const setRefs = useCallback(
		(node) => {
			// Ref's from useRef needs to have the node assigned to `current`
			ref.current = node;
			inViewRef(node);
		},
		[inViewRef],
	);

	useEffect(() => {
		try {
			if (ref.current && inView && hasLoaded) {
				ref.current.currentTime = 0
				ref.current.play()
			} else {
				ref.current.pause()
			}
		} catch (error) {
			console.log(error)
		}
	}, [inView, ref, hasLoaded])

	return (
		<video onCanPlayThrough={() => {
			setHasLoaded(true)
		}} preload="meta" ref={setRefs} src={url} muted loop controls playsInline />
	)
}

export default Video